import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { PermisoDto } from '@models/seguridad/permisos/permisoDto.model';
import { PermisoService } from '@services/permiso/permiso.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { AppRoleDirective } from '@directives/appRoles/app-role.directive';
import { SharedModule } from '@modules/shared.module';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { DialogFormPermisoComponent } from '../dialog-form-permiso/dialog-form-permiso.component';
import { DialogParams } from '@interfaces/dialogParam.interface.model';

@Component({
  standalone: true,
  imports: [SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatDividerModule, NgxSpinnerModule, MatTableModule,
    MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule,
    FormsModule, AppRolesDirective, MatSortModule, MatTooltipModule,
    MatPaginatorModule, MatRippleModule, CommonModule
  ],
  selector: 'app-listado-permiso',
  templateUrl: './listado-permiso.component.html',
  styleUrls: ['./listado-permiso.component.css'],
})
export class ListadoPermisoComponent implements OnInit {

  data = false
  dataSource = new MatTableDataSource<PermisoDto>();
  obj!: undefined
  displayedColumns: string[] = [];

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

  private paginator!: MatPaginator;
  private sort!: MatSort;
  checkedFiltroAvanzado!: boolean;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(
    public dialog: MatDialog,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private permisoService: PermisoService
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'accion'] :
        ['descripcion', 'token', 'casoUso', 'rol', 'accion'];
    });

  }
  ngOnInit() {
  }


  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }




  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "70%"
        break;

      default:
        dialogConfig.width = "50%"
        break;
    }

    const dialogRef = this.dialog.open(DialogFormPermisoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = (data: any, filter: string) => {
      let searchTerms = JSON.parse(filter);
      return data.name.toLowerCase().indexOf(searchTerms.userName) !== -1
        && data.estado.toString().toLowerCase().indexOf(searchTerms.activo) !== -1
    }
    return filterFunction;
  }

  sortingDataAccessor() {
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'descripcion':
          return item.descripcion?.toLowerCase() || '';
        case 'token':
          return `${item.token || ''} ${item.usuario?.apellido || ''}`.toLowerCase();
        case 'casoUso':
          return item.casoUso?.toLowerCase() || '';
        case 'rol':
          return item.descripcion?.toLowerCase() || '';
        default:
          return item[property];
      }
    };
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.sortingDataAccessor()
  }

  iniciaFiltroTabla() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const search = filter.trim().toLowerCase();
      return (
        data.usuario?.userName?.toLowerCase().includes(search) ||
        data.usuario?.nombre?.toLowerCase().includes(search) ||
        data.usuario?.apellido?.toLowerCase().includes(search) ||
        data.usuario?.correo?.toLowerCase().includes(search) ||
        data.rol?.descripcion?.toLowerCase().includes(search)
      );
    }
  }

  // guardarFiltro() {
  //   const filtro: UsuarioFilter = this.formFilter.value;
  //   localStorage.setItem('filtroUsuarioEmpresaGuardado', JSON.stringify(filtro));
  // }

  // limpiarFiltro() {
  //   this.formFilter.reset();
  //   localStorage.removeItem('filtroUsuarioEmpresaGuardado');
  // }

  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

  aplicarFiltro() {
    this.getAllByFilter();
    //this.guardarFiltro();
  }

  getAllByFilter() {
    this.spinner.show("spPermisos")
    this.permisoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spPermisos")
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide("spPermisos")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  applyFilter(event: any) {
    if (event && event.target && event.target instanceof HTMLInputElement) {
      let filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }


}
